// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".qr-floating-btn[data-v-69b9db11]{position:absolute;top:44px;left:14px;z-index:20;background-color:hsla(0,0%,100%,.9)!important}", ""]);
// Exports
module.exports = exports;
